import { render, staticRenderFns } from "./folders.vue?vue&type=template&id=18f38a19&scoped=true&"
import script from "./folders.vue?vue&type=script&lang=js&"
export * from "./folders.vue?vue&type=script&lang=js&"
import style0 from "./folders.vue?vue&type=style&index=0&id=18f38a19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f38a19",
  null
  
)

export default component.exports